//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconPersonAddFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3.3 13L0.75 20H12.99L12.27 18.01L8.25 18L8.98 16L13.67 16.01L15.12 20H17.25L14.7 13H3.3Z" fill="currentColor" /><path d="M20 9V6H18V9H15V11H18V14H20V11H23V9H20Z" fill="currentColor" /><path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" fill="currentColor" /></svg>;
}
export default IconPersonAddFill;